import { Box, styled } from '@mui/material';
import { ControlledTextInput, WsColors } from 'wisestep-base';

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
}));

export const AppLayoutTheme = styled(Box)(() => ({
  borderRadius: 8,
  backgroundColor: WsColors.TheBlues900,
}));

export const CustomTextField = styled(ControlledTextInput, {
  name: 'CustomTextField',
})({
  width: '90%',
});
